module.exports = __webpack_public_path__ + "media/images/flags/16/Belarus-a15f2954b344bf30f21f13d2215350c0.png";